(function () {
    function copyFallback(url) {
        const input = document.createElement('textarea');
        input.value = url;
        input.setAttribute('readonly', '');
        input.style.position = 'fixed';
        input.style.opacity = '0';
        document.body.appendChild(input);
        try {
            input.select();
            if (!document.execCommand('copy')) {
                throw new Error('Copy failed');
            }
        } finally {
            input.remove();
        }
    }

    document.querySelectorAll('[data-copy-link]').forEach(function (button) {
        const label = button.querySelector('[data-copy-label]');
        const originalLabel = label.textContent;
        let resetTimer;

        button.addEventListener('click', async function () {
            clearTimeout(resetTimer);
            button.disabled = true;
            try {
                if (navigator.clipboard && navigator.clipboard.writeText) {
                    try {
                        await navigator.clipboard.writeText(button.dataset.copyLink);
                    } catch (error) {
                        copyFallback(button.dataset.copyLink);
                    }
                } else {
                    copyFallback(button.dataset.copyLink);
                }
                label.textContent = button.dataset.copySuccess;
            } catch (error) {
                label.textContent = button.dataset.copyError;
            } finally {
                button.disabled = false;
                button.focus({preventScroll: true});
                resetTimer = setTimeout(function () {
                    label.textContent = originalLabel;
                }, 3000);
            }
        });
    });
})();
